import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import type { IconSize } from '@core/user-interface-legacy';
import { IconComponent } from '@core/user-interface-legacy';

type Color = 'default' | 'light';

@Component({
  selector: 'rt-hidden-score-icon',
  templateUrl: './hidden-score-icon.component.html',
  styleUrls: ['./hidden-score-icon.component.less'],
  host: {
    '[class]': 'color()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent],
})
export class HiddenScoreIconComponent {
  public readonly size = input<IconSize>('small');
  public readonly color = input<Color | undefined>('default');
  public readonly height = input<string | undefined>('auto');
}
